import React, { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router";
import TopBarProgress from "react-topbar-progress-indicator";
import { createSearchParams } from "react-router-dom";
import SearchFilter from "../../../components/CustomeFilter/SearchFilter";

import {
  getAttributeWithFilterCount
} from "../../../actions/filters";

import CustomeTableBtn from "../../../components/custome-table-button/CustomeTableBtn";
import { Pagination } from "@mui/material";
import DashboardPagesLayout from "../customerServiceDashboard/components/DashboardPagesLayout";

const GlobalCustomFilters = () => {
  // hooks
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  // Local State
  const [loading, setloading] = useState(true);
  const [Data, setData] = useState([]);
  const [pagination, setpagination] = useState({
    currentPage: 1,
  });
  const [SearchFilterr, setSearchFilterr] = useState({
    title: "",
  });

  // Api calls for get Order
  const getAttributes = useCallback(
    async (
      pageNo,
      title,
    ) => {
      setloading(true);
      const res = await dispatch(
        getAttributeWithFilterCount(
          pageNo,
          title
        )
      );
      if (res) {
        console.log({ res })
        setData(res?.attributes);
        setpagination(res?.pagination);
      }
      setloading(false);
    },
    [dispatch]
  );

  useEffect(() => {
    var timer = setTimeout(() => {
      getAttributes(pagination.currentPage, SearchFilterr.title);
    }, 1000);

    return () => {
      clearTimeout(timer);
    };
  }, [getAttributes, pagination.currentPage, SearchFilterr.title]);


  // handle page change
  const handleChange = (e, value) => {
    const options = {
      pathname: location.pathname,
      search: `?${createSearchParams({
        page: value,
      })}`,
    };
    navigate(options, { replace: true });
    setpagination({ ...pagination, currentPage: value });
  };

  const resetToFirstPage = () => {
    setpagination((prev) => ({ ...prev, currentPage: 1 }));
    navigate(
      {
        pathname: location.pathname,
        search: `?${createSearchParams({ page: 1 })}`,
      },
      { replace: true }
    );
  };



  return (
    <>
      {loading ? (
        <TopBarProgress />
      ) : (
        <>
          <div
            className=" d-flex  justify-content-end align-center flex-wrap"
            style={{ gap: "20px" }}
          >
            <SearchFilter
              type="text"
              placeholder={"Search Name"}
              value={SearchFilterr?.title}
              onChange={(e) => {
                resetToFirstPage();
                setSearchFilterr({
                  ...SearchFilterr,
                  title: e.target.value,
                });
              }}

            />


          </div>
          <div className=" my-5">
            <DashboardPagesLayout
              pageTitle="Global Custom Filters"
              subTitle="items"
              count={pagination?.count}
            >
              <div className="dashboard-pages-table">
                <table>
                  <thead>
                    <tr>
                      <th>Sn#</th>
                      <th>Parent Attribute</th>
                      <th>Custom Filters</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Data?.length ? (
                      <>
                        {Data?.map((item, i) => (
                          <tr key={item?._id}>
                            <td
                              className="order-item-number"
                              onClick={() =>
                                navigate(`/admin/view-order/${item?._id}`)
                              }
                            >
                              {i + 1}
                            </td>
                            <td>{item.name}</td>
                            <td>{item.filterCount}</td>

                            <td>
                              <CustomeTableBtn
                                color="black"
                                width={"100px"}
                                className={"mr-2"}
                                onClick={() =>
                                  navigate(
                                    `/admin/custom-global-filter-detail/${item._id}`
                                  )
                                }
                              >
                                View Custom Filters
                              </CustomeTableBtn>



                            </td>
                          </tr>
                        ))}
                      </>
                    ) : (
                      <>
                        <tr>
                          <td colSpan={9} className=" text-center">
                            {" "}
                            No Record Found
                          </td>
                        </tr>
                      </>
                    )}
                  </tbody>
                </table>

                <div className="d-flex justify-content-center align-center p-2">
                  <div className=" mx-auto">
                    <Pagination
                      count={pagination.totalPages}
                      page={pagination.currentPage}
                      onChange={handleChange}
                    />
                  </div>

                  <span
                    className=" font-weight-bold"
                    style={{ color: "#9f9f9f" }}
                  >
                    {Data?.length} of {pagination?.count} Items
                  </span>
                </div>
              </div>
            </DashboardPagesLayout>
          </div>
        </>
      )}
    </>
  );
};

export default GlobalCustomFilters;
